import { Injectable } from '@angular/core';
import { BehaviorSubject} from 'rxjs'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

/* Este servicio sirve para comunicar entre los componentes del router outlet y la cabecera navbar si debe cargar la 
* pública o la private. El componente llama a setNavBarState para indicar true->private o false->publica y la cabecera 
* está suscrita a NavbarPrivateObservable para cambiar según lo que se indique */
export class StateService {

  //navbar
  NavbarPrivateSubject = new BehaviorSubject<boolean>(false);
  NavbarPrivateObservable = this.NavbarPrivateSubject.asObservable()

  constructor(private http: HttpClient) { }

  /* set Navbar private o publica */
  public setNavBarState(state:boolean){
    this.NavbarPrivateSubject.next(state)
  }

  /* Get maintenance status */
  public getMaitenanceStatus(): Observable<any>{
    return this.http.get('../assets/json/status.json')
  }
  
}





// export class ComunicacionesService {



//   constructor() { }

//   /* Navbar private o publica */
//   public setNavBarState(state:boolean){
//     this.navbarPrivate = state
//     this.NavbarPrivateSubject.next(state)
//   }

// }
